import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, ShieldCheck, Heart } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-zinc-950 border-t border-zinc-900 pt-16 pb-8 text-zinc-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          
          {/* Column 1: Brand details */}
          <div className="flex flex-col space-y-4">
            <Link to="/" className="flex items-center gap-3 group">
              <div className="h-10 w-10 rounded-full overflow-hidden border border-zinc-850 bg-zinc-950 flex-shrink-0">
                <img
                  src="https://customer-assets-0z36b82j.emergentagent.net/job_garage-redesign-2/artifacts/ett2zuzs_logo%20nobg.webp"
                  alt="KG Auto Logo"
                  className="w-full h-full object-cover scale-105"
                />
              </div>
              <span className="font-extrabold text-xl tracking-wider text-white">
                KG <span className="text-blue-500">AUTO REPAIR</span>
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-zinc-400 mt-2">
              Family-owned & operated auto repair business serving Preston County, WV, and surrounding areas. Reliable mobile and in-shop services whenever, wherever you need us.
            </p>
            <div className="flex items-center gap-2 pt-2 text-xs font-semibold text-blue-500 uppercase tracking-widest">
              <ShieldCheck className="h-4 w-4" />
              <span>DIRECT COMMUNICATION WITH MECHANIC</span>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-widest mb-4">Our Services</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/services/mobile-mechanic-service" className="hover:text-blue-500 transition-colors">
                  Mobile Mechanic
                </Link>
              </li>
              <li>
                <Link to="/services/engine-rebuilding-and-repair" className="hover:text-blue-500 transition-colors">
                  Engine Rebuilding
                </Link>
              </li>
              <li>
                <Link to="/services/euro-vehicle-repair" className="hover:text-blue-500 transition-colors">
                  European Auto Repair
                </Link>
              </li>
              <li>
                <Link to="/services/brake-repair" className="hover:text-blue-500 transition-colors">
                  Brake Repair Services
                </Link>
              </li>
              <li>
                <Link to="/services/heat-and-ac-repair" className="hover:text-blue-500 transition-colors">
                  Heat & AC Services
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Shop Location & Hours */}
          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-widest mb-4">Garage Hours</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-2.5">
                <Clock className="h-5 w-5 text-blue-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="font-semibold text-zinc-300">Mon - Fri: 9:00 AM - 6:00 PM</p>
                  <p className="text-zinc-500 text-xs mt-0.5">Saturday: Call/Text for availability</p>
                  <p className="text-zinc-500 text-xs">Sunday: Call/Text for availability</p>
                </div>
              </div>
              <div className="flex items-start gap-2.5">
                <MapPin className="h-5 w-5 text-blue-500 flex-shrink-0 mt-0.5" />
                <span className="text-zinc-300">
                  481 Indian Rock Road<br />Reedsville WV, 26547
                </span>
              </div>
            </div>
          </div>

          {/* Column 4: Urgent Support */}
          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-widest mb-4">Emergency Contact</h4>
            <p className="text-sm leading-relaxed mb-4">
              Need on-site diagnostics or got stranded? Reach out directly via text or call:
            </p>
            <div className="space-y-3">
              <a
                href="tel:3046853724"
                className="flex items-center gap-2.5 text-white font-extrabold hover:text-blue-500 transition-colors"
              >
                <Phone className="h-5 w-5 text-blue-500" />
                <span>304-685-3724 (Grant)</span>
              </a>
              <a
                href="mailto:kgauto304@gmail.com"
                className="flex items-center gap-2.5 text-zinc-300 hover:text-blue-500 transition-colors text-sm"
              >
                <Mail className="h-5 w-5 text-zinc-500" />
                <span>kgauto304@gmail.com</span>
              </a>
            </div>
          </div>

        </div>

        {/* Bottom divider and sub-footer */}
        <div className="border-t border-zinc-900 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs">
          <p>© {currentYear} KG Auto Repair. All rights reserved. Designed for ultimate premium performance.</p>
        </div>
      </div>
    </footer>
  );
}
